
import Vue from "vue";
import dayjs from "dayjs";
import axios from "axios";
import XLSX from "xlsx";
import { Chart } from "highcharts-vue";
import ButtonDanger from "@/components/ButtonDanger.vue";
import ButtonReload from "@/components/ButtonReload.vue";
import DateTimeRange from "@/components/DateTimeRange.vue";
import LoadingGraph from "@/components/LoadingGraph.vue";
import NoDataAvailable from "@/components/NoDataAvailable.vue";
export default Vue.extend({
  name: "TrHealthMonitoringGraph",
  components: { highcharts: Chart, ButtonDanger, ButtonReload, DateTimeRange, LoadingGraph, NoDataAvailable },
  data() {
    const date = new Date();
    return {
      source: null,
      isSensorType: {},
      sensorTypeData: [],
      selectDateType: "normal",
      startDate: dayjs(date).subtract(30, "day").format("YYYY-MM-DDT00:00:00"),
      endDate: dayjs(date).format("YYYY-MM-DDT23:59:59"),
      isNormal: true,
      chartResultData: [],
      chartLoading: true,
      chartOptions: {
        chart: {
          type: "line",
          height: 450,
          zoomType: "xy",
          borderWidth: 3,
          borderRadius: 6,
          borderColor: "#F1EFEF",
          spacing: [30, 50, 30, 50],
        },
        title: { text: null },
        subtitle: { text: null },
        tooltip: { shared: true, crosshairs: true },
        legend: {
          layout: "horizontal",
          align: "left",
          verticalAlign: "top",
          itemStyle: { fontSize: "12px", fontWeight: "300", color: "#000000" },
        },
        yAxis: {
          type: "logarithmic",
          max: 10000,
        },
        xAxis: { type: "category", categories: [] },
        series: [],
        credits: { enabled: false },
        plotOptions: {
          series: {
            events: {
              legendItemClick: function () {
                const series = this.chart.series;
                const seriesIndex = this.index;
                const dataMax = (!this.visible && this.dataMax) || undefined;
                const values = [];
                dataMax && values.push(dataMax);
                this.chart.series.forEach((series, index) => {
                  if (index !== seriesIndex && series.visible) values.push(series.dataMax);
                });
                if (this.name === "All" && this.visible) {
                  series.forEach((val, ind) => {
                    if (ind !== seriesIndex) val.setVisible(false);
                  });
                  return;
                } else if (this.name === "All" && !this.visible) {
                  series.forEach((val, ind) => {
                    if (ind !== seriesIndex) val.setVisible(true);
                  });
                  const remaining = series.filter((val) => val.visible);
                  const seriesY = remaining.map((val) => Math.max(...val.yData));
                  const maxY = Math.max(...[...seriesY]) + 40;

                  this.chart.yAxis[0].update({
                    type: "logarithmic",
                    visible: false,
                    min: null,
                    max: maxY,
                  });

                  this.chart.yAxis[0].removePlotLine("plot-warning");
                  this.chart.yAxis[0].removePlotLine("plot-alarm");
                  return;
                }
                setTimeout(() => {
                  const remaining = series.filter((val) => val.visible);
                  const count = remaining.length;
                  if (count === 1) {
                    const seriesY = remaining[0].yData;
                    const warning = remaining[0].options.warning;
                    const alarm = remaining[0].options.alarm;
                    const minY =
                      Math.min(...[...seriesY, warning, alarm]) >= 0 ? 0 : Math.min(...[...seriesY, warning, alarm]) - 40;
                    const maxY = Math.max(...[...seriesY, warning, alarm]) + 40;

                    this.chart.yAxis[0].update({
                      type: "linear",
                      visible: true,
                      title: { text: null },
                      min: minY,
                      max: maxY,
                    });
                    this.chart.yAxis[0].addPlotLine({
                      id: "plot-warning",
                      value: warning,
                      color: "#FCA239",
                      width: 2,
                      zIndex: 5,
                      label: {
                        useHTML: true,
                        text: `<div class="relative mt-[4px] bg-[#FCA239] p-[5px] text-white">
                      <span>Warning ${warning}</span>
                      </div>`,
                        align: "center",
                      },
                      dashStyle: "ShortDash",
                    });
                    this.chart.yAxis[0].addPlotLine({
                      id: "plot-alarm",
                      value: alarm,
                      color: "#D9263B",
                      width: 2,
                      zIndex: 5,
                      label: {
                        useHTML: true,
                        text: `<div class="relative mt-[4px] bg-[#D9263B] p-[5px] text-white">
                      <span>Alarm ${alarm}</span>
                      </div>`,
                        align: "center",
                      },
                      dashStyle: "ShortDash",
                    });
                  } else {
                    const seriesY = remaining.map((val) => Math.max(...val.yData));
                    const maxY = Math.max(...[...seriesY]) + 40;

                    this.chart.yAxis[0].update({
                      type: "logarithmic",
                      visible: false,
                      min: null,
                      max: maxY,
                    });

                    this.chart.yAxis[0].removePlotLine("plot-warning");
                    this.chart.yAxis[0].removePlotLine("plot-alarm");
                  }
                }, 100);
              },
              click: function () {
                const series = this.chart.series;
                const index = this.index;
                const seriesY = series[index].yData;
                const warning = series[index].options.warning;
                const alarm = series[index].options.alarm;
                const minY =
                  Math.min(...[...seriesY, warning, alarm]) >= 0 ? 0 : Math.min(...[...seriesY, warning, alarm]) - 40;
                const maxY = Math.max(...[...seriesY, warning, alarm]) + 40;
                series.forEach((val, ind) => {
                  if (ind !== index) {
                    val.setVisible(false);
                  }
                });
                setTimeout(() => {
                  this.chart.yAxis[0].update({
                    visible: true,
                    title: { text: null },
                    min: minY,
                    max: maxY,
                    type: "linear",
                  });

                  this.chart.yAxis[0].addPlotLine({
                    id: "plot-warning",
                    value: warning,
                    color: "#FCA239",
                    width: 2,
                    zIndex: 5,
                    label: {
                      useHTML: true,
                      text: `<div class="relative mt-[4px] bg-[#FCA239] p-[5px] text-white">
                      <span>Warning ${warning}</span>
                      </div>`,
                      align: "center",
                    },
                    dashStyle: "ShortDash",
                  });
                  this.chart.yAxis[0].addPlotLine({
                    id: "plot-alarm",
                    value: alarm,
                    color: "#D9263B",
                    width: 2,
                    zIndex: 5,
                    label: {
                      useHTML: true,
                      text: `<div class="relative mt-[4px] bg-[#D9263B] p-[5px] text-white">
                      <span>Alarm ${alarm}</span>
                      </div>`,
                      align: "center",
                    },
                    dashStyle: "ShortDash",
                  });
                }, 100);
              },
            },
          },
        },
      },
    };
  },
  computed: {
    model() {
      return this.$store.getters.model;
    },
    isSecondaryTab() {
      return this.$store.state.graphInformationTab.is_secondary_tab.id;
    },
  },
  async created() {
    await this.fetchSensorTypeData();
  },
  methods: {
    async fetchSensorTypeData() {
      try {
        const { id } = this.model;
        const response = await (this as any).$dep.modelUseCase.getModelHealthMonitoringSensorType(this.isSecondaryTab, id);
        this.sensorTypeData = response.map((prev) => ({ id: prev.id, name: prev.name }));
        this.isSensorType = { id: this.sensorTypeData[0].id, name: this.sensorTypeData[0].name };
      } catch (error) {
        this.sensorTypeData = [];
        this.isSensorType = {};
      }
    },
    async fetchResultData() {
      try {
        this.chartLoading = true;
        const { id, modelCode, equipmentId } = this.model;
        if (this.source) {
          this.source.cancel();
        }
        this.source = axios.CancelToken.source();
        const cancelToken = this.source.token;
        const response = await (this as any).$dep.modelUseCase.getTrHealMonitoringResultData(
          {
            modelId: id,
            modelCode: modelCode,
            sensorId: this.isSensorType.id,
            startDate: this.startDate,
            endDate: this.endDate,
            isNormal: this.isNormal,
            equipmentId: equipmentId,
          },
          cancelToken
        );
        this.chartResultData = response;
        this.chartOptions.title.text = `Health Monitoring : ${this.$store.state.graphInformationTab.is_secondary_tab.name}`;
        this.chartOptions.xAxis = this.aAxis(response);
        this.chartOptions.series = this.series(response);
        this.chartOptions.yAxis = { type: "logarithmic", max: Math.max(...response.map((val) => val.data).flat()) + 40 };
        this.chartLoading = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.source = null;
      }
    },
    onChangeSensorType(param: any) {
      const { id, name } = param;
      this.isSensorType = { id, name };
    },
    onChangeSelectDateType(param: any) {
      this.selectDateType = param;
    },
    aAxis(datas: any) {
      let labels = [];
      for (const res of datas) {
        labels.push(...res.timestamp);
      }
      const formatDate = labels.map((label) => dayjs(label).format("DD-MM-YYYY HH:mm"));
      const count = [...new Set(formatDate)].length;
      return {
        type: "category",
        labels: {
          align: "left",
          step: count <= 10 ? 0 : count <= 100 ? 1 : count <= 200 ? 2 : count <= 300 ? 3 : count <= 400 ? 4 : 5,
        },
        tickInterval: count <= 10 ? 0 : count <= 500 ? 15 : 100,
        categories: [...new Set(formatDate)],
      };
    },
    series(datas: any) {
      const customLegend = {
        name: "All",
      };
      const sers = datas.map((prev) => ({
        name: prev.tagCode,
        data: prev.data,
        tooltip: { valueSuffix: ` ${prev.unit}` },
        lineWidth: 2,
        warning: prev.warning,
        alarm: prev.alarm,
      }));
      const newsers = [customLegend].concat(sers);
      return newsers;
    },
    async onChangeDate(ev: any) {
      this.startDate = dayjs(ev.startDate).subtract(7, "hour").format("YYYY-MM-DDTHH:mm:ss");
      this.endDate = dayjs(ev.endDate).subtract(7, "hour").format("YYYY-MM-DDTHH:mm:ss");
      await this.fetchResultData();
    },
    async reloadData() {
      await this.fetchResultData();
    },
    exportExcel() {
      const { id } = this.model;
      const name = `tr_${id}__health_monitoring`.toUpperCase();
      // const values = (this as any).chartResultData.data.map((val) => val);
      // const timestamp = (this as any).chartResultData.timestamp.map((val) => val);
      const ws = XLSX.utils.json_to_sheet(this.chartResultData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, name); // => sheet name
      XLSX.writeFile(wb, `${name}.xlsx`); // => file name
    },
  },
  watch: {
    async isSecondaryTab() {
      await this.fetchSensorTypeData();
    },
    async isSensorType() {
      await this.fetchResultData();
    },
    async selectDateType() {
      if (this.selectDateType === "yearly") {
        this.isNormal = false;
      } else {
        this.isNormal = true;
      }
    },
  },
});
